<template>
  <div class="shift-manage-page">
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button
              type="primary"
              size="medium"
              v-if="buttonType === 'icon'"
              icon="iconfont icon-tianjiacaidan2"
              @click="handleAdd"
            ></el-button>
            <el-button
              type="primary"
              size="medium"
              v-if="buttonType === 'text'"
              @click="handleAdd"
              >新增</el-button
            >
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form
            size="medium"
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="班次名称">
              <el-input
                v-model="searchCondition.name"
                placeholder="请输入班次名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="考勤时间">
              <el-time-picker
                is-range
                v-model="searchCondition.time_range"
                range-separator="—"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="HH:mm"
                format="HH:mm"
                clearable
              >
              </el-time-picker>
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                v-model="searchCondition.status"
                placeholder="全部"
                clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="启用" :value="1"></el-option>
                <el-option label="停用" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
              <el-button @click="resetSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="tableList"
          :columns="columns"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 1 ? 'success' : 'info'"
                size="small"
              >
                {{ scope.row.status === 1 ? "启用" : "停用" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleView(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleEdit(scope.row.id)"
                >编辑</el-button
              >
              <el-popover
                placement="top"
                width="150"
                v-model="scope.row.visible"
              >
                <p>确定要删除该班次吗？</p>
                <div style="text-align: right; margin: 0;">
                  <el-button
                    type="text"
                    size="mini"
                    @click="scope.row.visible = false"
                    >取消</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    @click="handleDelete(scope.row.id)"
                    >确定</el-button
                  >
                </div>
                <el-button
                  slot="reference"
                  size="mini"
                  type="text"
                  style="color: #F56C6C;"
                  >删除</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <!-- 查看班次弹窗 -->
    <el-dialog
      title="查看班次"
      :visible.sync="viewDialog.visible"
      width="950px"
      :close-on-click-modal="false"
    >
      <el-form label-position="right" label-width="96px">
        <el-form-item label="班次名称:">
          <span>{{ viewDialog.data.shift_name }}</span>
        </el-form-item>
        <el-form-item label="上下班时段:">
          <el-table
            :data="viewPeriodTableRows"
            border
            size="small"
            style="width: 100%;"
            :span-method="viewPeriodSpanMethod"
          >
            <el-table-column label="打卡次数" align="center" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.rowType === 'in'">
                  {{ "第" + (scope.row.periodIndex + 1) + "次" }}
                </div>
                <div>
                  (工时:{{ calcWorkHours(scope.row.period) }}H)
                </div>
              </template>
            </el-table-column>
            <el-table-column label="上下班" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.rowType === "in" ? "上班" : "下班" }}
              </template>
            </el-table-column>
            <el-table-column label="工作时间" align="center" width="150">
              <template slot-scope="scope">
                {{ (scope.row.rowType === "in" ? scope.row.period.clock_in : scope.row.period.clock_out) || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="中途休息时间" align="center" width="180">
              <template slot-scope="scope">
                <template v-if="scope.row.rowType === 'in'">
                  {{ scope.row.period.break_time }}
                </template>
              </template>
            </el-table-column>
            <el-table-column label="打卡开始时间" align="center" width="142">
              <template slot-scope="scope">
                {{ scope.row.period.punch_start_time || (scope.row.rowType === "in" ? scope.row.period.in_start : scope.row.period.out_start) || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="打卡结束时间" align="center" width="120">
              <template slot-scope="scope">
                {{ scope.row.period.punch_end_time || (scope.row.rowType === "in" ? scope.row.period.in_end : scope.row.period.out_end) || "-" }}
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch :value="viewDialog.data.status === 1" disabled></el-switch>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 新增/编辑班次弹窗 -->
    <el-dialog
      :title="editDialog.title"
      :visible.sync="editDialog.visible"
      width="950px"
      :close-on-click-modal="false"
      @close="handleEditClose"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="shiftForm"
        label-position="right"
        label-width="96px"
      >
        <el-form-item label="班次名称:" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入班次名称"
            style="width: 240px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="上下班时段:" required>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addPeriod"
            >添加</el-button
          >
          <div class="period-table">
            <el-table
              :data="periodTableRows"
              border
              size="small"
              style="width: 100%; margin-top: 10px;"
              :span-method="periodSpanMethod"
            >
              <el-table-column label="打卡次数" align="center" width="100">
                <template slot-scope="scope">
                  <div>
                    {{ "第" + (scope.row.periodIndex + 1) + "次" }}
                  </div>
                  <div>(工时:{{ calcWorkHours(scope.row.period) }}H)</div>
                </template>
              </el-table-column>
              <el-table-column label="上下班" align="center" width="80">
                <template slot-scope="scope">
                  {{ scope.row.rowType === "in" ? "上班" : "下班" }}
                </template>
              </el-table-column>
              <el-table-column label="工作时间" align="center" width="133">
                <template slot-scope="scope">
                  <el-time-picker
                    v-model="
                      scope.row.period[
                        scope.row.rowType === 'in' ? 'clock_in' : 'clock_out'
                      ]
                    "
                    format="HH:mm"
                    value-format="HH:mm"
                    :placeholder="
                      scope.row.rowType === 'in' ? '上班时间' : '下班时间'
                    "
                    size="small"
                    style="width: 100%;"
                  >
                  </el-time-picker>
                </template>
              </el-table-column>
              <el-table-column label="中途休息时间" align="center" width="200">
                <template slot-scope="scope">
                  <template v-if="scope.row.rowType === 'in'">
                    <el-time-picker
                      is-range
                      v-model="scope.row.period.break_time"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      format="HH:mm"
                      value-format="HH:mm"
                      size="small"
                      style="width: 100%;"
                    >
                    </el-time-picker>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="打卡开始时间" align="center" width="120">
                <template slot-scope="scope">
                  <el-time-picker
                    v-model="
                      scope.row.period[
                        scope.row.rowType === 'in' ? 'in_start' : 'out_start'
                      ]
                    "
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="选择时间"
                    size="small"
                    style="width: 100%;"
                    :picker-options="scope.row.rowType === 'in' ? getInStartPickerOptions(scope.row.period) : getOutStartPickerOptions(scope.row.period)"
                  >
                  </el-time-picker>
                </template>
              </el-table-column>
              <el-table-column label="打卡结束时间" align="center" width="120">
                <template slot-scope="scope">
                  <el-time-picker
                    v-model="
                      scope.row.period[
                        scope.row.rowType === 'in' ? 'in_end' : 'out_end'
                      ]
                    "
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="选择时间"
                    size="small"
                    style="width: 100%;"
                    :picker-options="scope.row.rowType === 'in' ? getInEndPickerOptions(scope.row.period) : getOutEndPickerOptions(scope.row.period)"
                  >
                  </el-time-picker>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="60">
                <template slot-scope="scope">
                  <template v-if="scope.row.rowType === 'in'">
                    <el-button
                      type="text"
                      size="small"
                      style="color: #F56C6C;"
                      @click="removePeriod(scope.row.periodIndex)"
                      :disabled="scope.row.periodIndex === 0"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch
            v-model="formData.status"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialog.visible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleSubmit"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import { mapGetters } from "vuex";

export default {
  name: "ShiftManage",
  components: { PageHeaderLayout, ApeTable },
  data() {
    return {
      searchCondition: {
        name: "",
        time_range: null,
        status: "",
      },
      loadingStatus: true,
      columns: [
        {
          title: "班次名称",
          value: "shift_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "考勤时间",
          value: "attendance_time",
          header_align: "center",
          align: "center",
        },
        {
          title: "更新时间",
          value: "updated_at",
          header_align: "center",
          align: "center",
        },
      ],
      tableList: [],
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      offset: 0,
      // 查看弹窗
      viewDialog: {
        visible: false,
        data: { shift_name: "", periods: [], status: 1 },
      },
      // 编辑/新增弹窗
      editDialog: {
        visible: false,
        title: "新增班次",
      },
      formData: {
        id: null,
        name: "",
        status: 1,
        periods: [
          {
            clock_in: "",
            clock_out: "",
            break_time: null,
            in_start: "",
            in_end: "",
            out_start: "",
            out_end: "",
          },
        ],
      },
      rules: {
        name: [{ required: true, message: "请输入班次名称", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    // 每个 period 展开为两行：上班、下班
    periodTableRows() {
      const rows = [];
      this.formData.periods.forEach((period, index) => {
        rows.push({ periodIndex: index, rowType: "in", period });
        rows.push({ periodIndex: index, rowType: "out", period });
      });
      return rows;
    },
    // 查看弹窗用：从 viewDialog.data.periods 展开为两行
    viewPeriodTableRows() {
      const periods = this.viewDialog.data.periods || [];
      const rows = [];
      periods.forEach((period, index) => {
        rows.push({ periodIndex: index, rowType: "in", period });
        rows.push({ periodIndex: index, rowType: "out", period });
      });
      return rows;
    },
  },
  methods: {
    // 接口 periods（按 round_no + clock_type）转为表单 periods（每组上班+下班合并为一条）
    apiPeriodsToFormPeriods(apiPeriods) {
      if (!apiPeriods || !apiPeriods.length) return [];
      const byRound = {};
      apiPeriods.forEach((p) => {
        const r = p.round_no != null ? p.round_no : 0;
        if (!byRound[r]) byRound[r] = {};
        if (p.clock_type === 1) byRound[r].in = p;
        else if (p.clock_type === 2) byRound[r].out = p;
      });
      return Object.keys(byRound)
        .sort((a, b) => Number(a) - Number(b))
        .map((r) => {
          const { in: inP, out: outP } = byRound[r];
          return {
            clock_in: inP ? inP.work_time : "",
            clock_out: outP ? outP.work_time : "",
            break_time: inP && inP.break_time ? inP.break_time : null,
            in_start: inP ? inP.punch_start_time : "",
            in_end: inP ? inP.punch_end_time : "",
            out_start: outP ? outP.punch_start_time : "",
            out_end: outP ? outP.punch_end_time : "",
            work_time: inP ? inP.work_time : "",
            punch_start_time: inP ? inP.punch_start_time : "",
            punch_end_time: inP ? inP.punch_end_time : "",
          };
        });
    },
    // 表单 periods 转为接口 periods
    formPeriodsToApiPeriods(formPeriods) {
      if (!formPeriods || !formPeriods.length) return [];
      const list = [];
      formPeriods.forEach((p, index) => {
        const roundNo = index + 1;
        const breakTime = Array.isArray(p.break_time)
          ? p.break_time.join("-")
          : p.break_time && typeof p.break_time === "string"
          ? p.break_time
          : "";
        list.push({
          round_no: roundNo,
          clock_type: 1,
          work_time: p.clock_in || p.work_time,
          break_time: breakTime || undefined,
          punch_start_time: p.in_start || p.punch_start_time || undefined,
          punch_end_time: p.in_end || p.punch_end_time || undefined,
          sort: list.length,
        });
        list.push({
          round_no: roundNo,
          clock_type: 2,
          work_time: p.clock_out,
          punch_start_time: p.out_start || undefined,
          punch_end_time: p.out_end || undefined,
          sort: list.length,
        });
      });
      return list;
    },
    // 时间 HH:mm 转 HH:mm:00，用于 selectableRange
    timeToRangeStr(t) {
      if (!t) return null;
      const s = String(t).trim();
      return s.length === 5 && s.indexOf(":") === 2 ? `${s}:00` : s;
    },
    // 时间加 N 小时，返回 HH:mm
    addHoursToTime(t, hours) {
      if (!t) return null;
      const [h, m] = String(t).split(":").map(Number);
      if (Number.isNaN(h)) return null;
      const totalMin = (h || 0) * 60 + (Number.isNaN(m) ? 0 : m) + hours * 60;
      const h2 = Math.floor(totalMin / 60) % 24;
      const m2 = totalMin % 60;
      return `${String(h2).padStart(2, "0")}:${String(m2).padStart(2, "0")}`;
    },
    // 上班打卡开始：不能晚于上班工作时间，可选 00:00 至 上班工作时间
    getInStartPickerOptions(period) {
      const end = this.timeToRangeStr(period.clock_in);
      if (!end) return {};
      return { selectableRange: `00:00:00 - ${end}` };
    },
    // 上班打卡结束：不能晚于上班工作时间1小时，可选 上班工作时间 至 上班时间+1h
    getInEndPickerOptions(period) {
      const start = this.timeToRangeStr(period.clock_in);
      const end = this.timeToRangeStr(this.addHoursToTime(period.clock_in, 1));
      if (!start || !end) return {};
      return { selectableRange: `${start} - ${end}` };
    },
    // 下班打卡开始：不能早于下班工作时间，可选 下班工作时间 至 23:59
    getOutStartPickerOptions(period) {
      const start = this.timeToRangeStr(period.clock_out);
      if (!start) return {};
      return { selectableRange: `${start} - 23:59:59` };
    },
    // 下班打卡结束：不能早于下班工作时间、不能晚于下班工作时间2小时（跨日则截断到 23:59）
    getOutEndPickerOptions(period) {
      const start = this.timeToRangeStr(period.clock_out);
      const endRaw = this.addHoursToTime(period.clock_out, 2);
      if (!start || !endRaw) return {};
      const toM = (str) => {
        const [a, b] = String(str).split(":").map(Number);
        return (a || 0) * 60 + (Number.isNaN(b) ? 0 : b);
      };
      const endM = toM(endRaw);
      const startM = toM(period.clock_out);
      const end = endM <= startM ? "23:59:59" : this.timeToRangeStr(endRaw);
      return { selectableRange: `${start} - ${end}` };
    },
    // 合并单元格：打卡次数(0)、中途休息时间(3)、操作(6)
    periodSpanMethod({ row, columnIndex }) {
      const colsToMerge = [0, 3, 6];
      if (!colsToMerge.includes(columnIndex)) return [1, 1];
      if (row.rowType === "out") return [0, 0];
      return [2, 1];
    },
    viewPeriodSpanMethod({ row, columnIndex }) {
      const colsToMerge = [0, 3];
      if (!colsToMerge.includes(columnIndex)) return [1, 1];
      if (row.rowType === "out") return [0, 0];
      return [2, 1];
    },
    formatBreakTime(breakTime) {
      if (!breakTime) return "-";
      if (Array.isArray(breakTime) && breakTime.length === 2)
        return breakTime.join("-");
      if (breakTime.start && breakTime.end)
        return breakTime.start + "-" + breakTime.end;
      return "-";
    },
    // 工时 = 下班时间 - 上班时间 - 休息时间（小时）
    calcWorkHours(period) {
      if (!period.clock_in || !period.clock_out) return "-";
      const toMin = (t) => {
        const [h, m] = String(t)
          .split(":")
          .map(Number);
        return (h || 0) * 60 + (m || 0);
      };
      let minutes = toMin(period.clock_out) - toMin(period.clock_in);
      if (period.break_time && period.break_time.length === 2) {
        const breakMin =
          toMin(period.break_time[1]) - toMin(period.break_time[0]);
        minutes -= breakMin;
      }
      if (minutes <= 0) return "0";
      return (minutes / 60).toFixed(1).replace(/\.0$/, "");
    },
    searchButton() {
      this.initList();
    },
    resetSearch() {
      this.searchCondition = { name: "", time_range: null, status: "" };
      this.initList();
    },
    async switchPaging() {
      this.initList();
    },
    // 新增
    handleAdd() {
      this.editDialog.title = "新增班次";
      this.formData = {
        id: null,
        name: "",
        status: 1,
        periods: [
          {
            clock_in: "",
            clock_out: "",
            break_time: null,
            in_start: "",
            in_end: "",
            out_start: "",
            out_end: "",
          },
        ],
      };
      this.editDialog.visible = true;
    },
    // 查看（列表无 periods，需请求详情）
    async handleView(row) {
      const res = await this.$api.getShiftInfo(row.id);
      const info = res.data || res.info || res;
      this.viewDialog.data = {
        shift_name: info.shift_name || row.shift_name,
        periods: info.periods && info.periods.length ? this.apiPeriodsToFormPeriods(info.periods) : [],
        status: info.status != null ? info.status : row.status,
      };
      this.viewDialog.visible = true;
    },
    // 编辑
    async handleEdit(id) {
      this.editDialog.title = "编辑班次";
      const res = await this.$api.getShiftInfo(id);
      const info = res.data || res.info || res;
      const formPeriods =
        info.periods && info.periods.length
          ? this.apiPeriodsToFormPeriods(info.periods)
          : [
              {
                clock_in: "",
                clock_out: "",
                break_time: null,
                in_start: "",
                in_end: "",
                out_start: "",
                out_end: "",
              },
            ];
      this.formData = {
        id: info.id,
        name: info.shift_name || info.name,
        status: info.status != null ? info.status : 1,
        periods: formPeriods,
      };
      this.editDialog.visible = true;
    },
    // 删除
    async handleDelete(id) {
      const res = await this.$api.deleteShift(id);
      if (res && res.code === 0) {
        this.$message.success("删除成功!");
        this.initList("del");
      } else {
        this.$message.error((res && res.msg) || "删除失败");
      }
    },
    // 添加时段（一次添加上班+下班两行）
    addPeriod() {
      this.formData.periods.push({
        clock_in: "",
        clock_out: "",
        break_time: null,
        in_start: "",
        in_end: "",
        out_start: "",
        out_end: "",
      });
    },
    // 删除时段行
    removePeriod(index) {
      this.formData.periods.splice(index, 1);
    },
    // 校验时段是否重叠
    checkPeriodsOverlap() {
      const periods = this.formData.periods;
      for (let i = 0; i < periods.length; i++) {
        if (!periods[i].clock_in || !periods[i].clock_out) {
          this.$message.error(`第${i + 1}个时段的上下班时间不能为空`);
          return false;
        }
        for (let j = i + 1; j < periods.length; j++) {
          if (!periods[j].clock_in || !periods[j].clock_out) continue;
          if (this.isTimeOverlap(periods[i], periods[j])) {
            this.$message.error(
              `第${i + 1}个时段与第${j + 1}个时段工作时间重叠`,
            );
            return false;
          }
        }
      }
      return true;
    },
    isTimeOverlap(a, b) {
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      const aStart = toMin(a.clock_in);
      const aEnd = toMin(a.clock_out);
      const bStart = toMin(b.clock_in);
      const bEnd = toMin(b.clock_out);
      return aStart < bEnd && bStart < aEnd;
    },
    // 上班：打卡开始时间不能晚于工作时间；下班：打卡开始时间不能早于工作时间
    checkPunchTimeRange() {
      const toMin = (t) => {
        if (!t) return null;
        const parts = String(t).split(":");
        const h = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);
        if (Number.isNaN(h)) return null;
        return (h || 0) * 60 + (Number.isNaN(m) ? 0 : m);
      };
      const periods = this.formData.periods || [];
      for (let i = 0; i < periods.length; i++) {
        const p = periods[i];
        const workIn = toMin(p.clock_in);
        const workOut = toMin(p.clock_out);
        const punchInStart = toMin(p.in_start);
        const punchOutStart = toMin(p.out_start);
        if (workIn != null && punchInStart != null && punchInStart > workIn) {
          this.$message.error(`第${i + 1}个时段：上班打卡开始时间不能晚于上班工作时间`);
          return false;
        }
        if (workOut != null && punchOutStart != null && punchOutStart < workOut) {
          this.$message.error(`第${i + 1}个时段：下班打卡开始时间不能早于下班工作时间`);
          return false;
        }
      }
      return true;
    },
    // 提交
    handleSubmit() {
      this.$refs["shiftForm"].validate((valid) => {
        if (!valid) {
          this.$message.error("请检查必填项！");
          return;
        }
        if (!this.checkPeriodsOverlap()) return;
        if (!this.checkPunchTimeRange()) return;
        this.formSubmit();
      });
    },
    async formSubmit() {
      const payload = {
        shift_name: this.formData.name,
        status: this.formData.status,
        periods: this.formPeriodsToApiPeriods(this.formData.periods),
      };
      if (this.formData.id) payload.id = this.formData.id;
      const res = await this.$api.saveShift(payload);
      const id = res && (res.data !== undefined ? res.data : res.id != null ? res.id : res);
      if (id) {
        this.$message.success("保存成功!");
        this.editDialog.visible = false;
        this.initList();
      } else if (res && res.code !== 0) {
        this.$message.error(res.msg || "保存失败");
      }
    },
    handleEditClose() {
      this.$nextTick(() => {
        if (this.$refs["shiftForm"]) {
          this.$refs["shiftForm"].resetFields();
        }
      });
    },
    // 初始化列表
    async initList(type) {
      this.loadingStatus = true;
      const pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      const params = {
        shift_name: this.searchCondition.name || undefined,
        attendance_time: this.searchCondition.time_range && this.searchCondition.time_range.length === 2
          ? `${this.searchCondition.time_range[0]}-${this.searchCondition.time_range[1]}`
          : undefined,
        status: this.searchCondition.status === "" ? undefined : this.searchCondition.status,
        ...pagingInfo,
      };
      const res = await this.$api.getShiftList(params);
      const list = res.data || res.list || [];
      const pages = res.pages || {};
      this.tableList = list;
      this.pagingData.total = pages.total || 0;
      this.offset = pages.offset || 0;
      this.loadingStatus = false;
    },
  },
  mounted() {
    this.initList();
  },
};
</script>

<style lang="scss" scoped>
.period-table {
  ::v-deep {
    .el-input--suffix .el-input__inner {
      padding-right: 10px;
    }
    .el-date-editor .el-range-input{
      width: 100%;
    }
    .el-table th {
      line-height: normal;
    }
  }
}
.shift-manage-page {
  ::v-deep {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
}
</style>
